<template lang="pug">
.admin-user-create
  v-toolbar(
    dark
    color="indigo"
    flat)
    v-toolbar-title 新增用戶
  v-container
    v-layout
      v-flex
        user-create-by-admin-form(ref="form")
        .caption.error--text(xs12)
          span {{ message }}
    v-layout
      v-flex.text-xs-center
        v-btn(
          :loading="loading"
          color="indigo"
          outline
          @click="submit") 送出
    check-dialog(:open="checkDialog"
      title="新增成功"
      @check="checkDialog = false")
</template>

<script>
import get from "lodash/get";
import errorParser from "@/utils/error";
import UserCreateByAdminForm from "@/components/UserCreateByAdminForm.vue";
import CheckDialog from "@/components/core/CheckDialog.vue";

export default {
  name: "AdminUserCreate",
  components: {
    UserCreateByAdminForm,
    CheckDialog
  },
  data() {
    return {
      loading: false,
      message: "",
      checkDialog: false
    };
  },
  methods: {
    async submit() {
      this.loading = true;
      this.message = "";

      try {
        const res = await this.$refs.form.submit();

        if (!res) {
          return (this.loading = false);
        }

        this.checkDialog = true;
        this.$refs.form.reset();
        this.loading = false;
      } catch (e) {
        this.message = errorParser(e);
        this.loading = false;
      }
    }
  }
};
</script>
